import IMask from 'imask'

export type InputType =
  | 'text'
  | 'number'
  | 'email'
  | 'password'
  | 'tel'
  | 'currency'
  | 'zip-code'
  | 'credit-card'
  | 'expiry'
  | 'date'
  | 'date-year'

export type AnyMaskedOptions = IMask.AnyMaskedOptions
